import axiosInstance from "@/api/axios-instance";
import { ProfessionalStatusLog } from "./change-professional-status";

export interface ProfessionalStatusLogsPage {
  logs: ProfessionalStatusLog[];
  total: number;
  page: number;
  lastPage: number;
  nextPage: number | null;
}

export async function getProfessionalStatusLogs(
  id: string,
  page = 0,
  limit = 20
): Promise<ProfessionalStatusLogsPage> {
  const response = await axiosInstance.get(`/professional/${id}/status-logs`, {
    params: { page, limit },
  });
  return response.data;
}
